import React, { Component } from "react";
import PropTypes from "prop-types";
import getUrlParams from "../../../../utils/getUrlParams";

class PackageTitle extends Component {
  state = {
    ref: React.createRef()
  };

  componentDidMount() {
    const urlPackage = `PID${getUrlParams().PID}`;
    const componentPackage = this.state.ref.current;
    if (componentPackage) {
      if (urlPackage === componentPackage.id) {
        const packagePlace = componentPackage;
        const offset = packagePlace.getBoundingClientRect();
        const newOffset = offset.top - 110;
        window.scrollTo(0, newOffset);
      }
    }
  }

  render() {
    const { packageName, moreInfoButton, packageID } = this.props;
    return (
      <div className="package__title">
        <div xs={12} sm={2}>
          {moreInfoButton}
        </div>
        <div xs={12} sm={10}>
          {packageID === 232 ? (
            <h3 ref={this.state.ref} id={`PID${packageID}`}>
              Complete Primary Package <br></br>
              {/* <span className="tnct__merit__plus">
                PLUS Testbase Standardised Tests & MERiT
              </span> */}
            </h3>
          ) : (
            <h3 ref={this.state.ref} id={`PID${packageID}`}>
              {packageName}
            </h3>
          )}
        </div>
      </div>
    );
  }
}

PackageTitle.propTypes = {
  packageName: PropTypes.string
};

export default PackageTitle;
